import { render } from "./Submission.vue?vue&type=template&id=371602a2&scoped=true"
import script from "./Submission.vue?vue&type=script&lang=js"
export * from "./Submission.vue?vue&type=script&lang=js"

import "./Submission.vue?vue&type=style&index=0&id=371602a2&scoped=true&lang=css"

import exportComponent from "D:\\dev\\DiagDev-clean\\Projets autres\\AdminWSInterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371602a2"]])

export default __exports__